import { appConfig } from "@/commons";
import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Typography,
  Button,
} from "@mui/material";

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");

  const [status, setStatus] = useState<"loading" | "success" | "error">(
    "loading",
  );
  const [message, setMessage] = useState<string>("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("Missing verification token.");
      return;
    }

    const verifyEmail = async () => {
      try {
        const res = await fetch(`${appConfig.api.baseUrl}/auth/verify-email`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ token }),
          credentials: "include",
        });

        if (!res.ok) {
          const text = await res.text();
          throw new Error(text || "Verification failed");
        }

        setStatus("success");
        setMessage("Your email has been verified successfully.");
      } catch (e: unknown) {
        const errorMessage =
          e instanceof Error ? e.message : "Verification failed.";

        setStatus("error");
        setMessage(errorMessage);
      }
    };

    verifyEmail();
  }, [token]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        p: 2,
      }}
    >
      <Card sx={{ maxWidth: 520, width: "100%" }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Email verification
          </Typography>

          {status === "loading" && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <CircularProgress size={20} />
              <Typography>Verifying…</Typography>
            </Box>
          )}

          {status !== "loading" && (
            <Typography sx={{ mt: 1 }}>{message}</Typography>
          )}

          <Box sx={{ mt: 3, display: "flex", gap: 1 }}>
            <Button variant="contained" onClick={() => navigate("/login")}>
              Go to login
            </Button>

            <Button variant="text" onClick={() => navigate("/")}>
              Home
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
